module.exports = __webpack_public_path__ + "img/安.cd26e97e.png";